import { BroadcastStatistic } from '~/entities/broadcast-statistic';
import { FileData } from '~/stores/broadcast.store';
import { CustomersFilter } from '~/entities/customer';
import { BaseCrudApi } from './abstract/base-crud.api';
import { SendPreviewMessageResponse } from './messages/broadcast/send-preview-message.response';
import { StatisticsListResponse } from './messages/broadcast/statistics-list.response';
import { UpdateBroadcastFileResponse } from './messages/broadcast/update-broadcast-file.response';

export type ResponseT<DataT> = { result: DataT }

export class BroadcastsApi extends BaseCrudApi {
  constructor() {
    super('broadcasts');
  }

  sendPreviewMessage(formData: FormData): Promise<SendPreviewMessageResponse> {
    return this.api.post('preview', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(res => res.data.result)
  }

  sendBroadcast(formData: FormData): Promise<SendPreviewMessageResponse> {
    return this.api.post('/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(res => res.data.result)
  }

  getStatistics(params?: { broadcastId: string }): Promise<StatisticsListResponse[]> {
    let queryParams = ''
    if (params?.broadcastId) {
      queryParams = `?broadcastId=${params.broadcastId}`
    }
    return this.api
      .get<ResponseT<StatisticsListResponse[]>>(`/statistics${queryParams}`)
      .then(res => res.data.result)
  }

  async stopSendingBroadcast(broadcastId: string) {
    return this.api.post(`${broadcastId}/stop-sending`).then(res => res.data.result);
  }

  async getFile(broadcastId: string): Promise<Blob> {
    const response = await fetch(`${this.baseURL}/header-file/${broadcastId}`);
    return await response.blob();
  }


  async validateTemplateCustomers(filters: CustomersFilter[]): Promise<string[]> {
    return this.api.post<any>(`validate`, { filters }).then(({ data }) => data);
  }

  updateBroadcastFile(broadcastId: string, data: FileData): Promise<UpdateBroadcastFileResponse> {
    const formData = new FormData();
    formData.append('headerFile', data.fileBinary);
    formData.append('broadcastId', broadcastId);
    const headers = { "Content-Type": "multipart/form-data" };

    return new Promise((resolve, reject) => {
      this.api.post<ResponseT<UpdateBroadcastFileResponse>>(`update-file`, formData, { headers })
        .then((res) => resolve(res.data.result))
        .catch(err => reject(err));
    })
  }
}
